import React from "react";
//Main Layout
import Nav from "./components/Nav";
import BackgroundVideo from "./components/BackgroundVideo";
import Discover from "./pages/Discover";
import Projects from "./pages/Projects";
import Services from "./pages/Services";
import Contact from "./pages/Contact";
import Footer from "./components/Footer";
//Global Styles
import GlobalStyle from "./styles/GlobalStyles";
import styled from "styled-components";
import logo from "./img/logo.svg";
//Scroll Top Function
import ScrollTop from "./ScrollTop";
//Router
import { Routes, Route, useLocation } from "react-router-dom";
//Global Context
import { useStateContext } from "./global-context/useGlobalContext";

function App() {
  const location = useLocation();
  const { loading } = useStateContext();
  return (
    <div className="App">
      <GlobalStyle />
      <ScrollTop />
      {loading && (
        <Logo className="logo">
          <img
            src={logo}
            alt="English Cocker Logo"
          />
        </Logo>
      )}
      <div className="clip">
        <header>
          <Nav />
        </header>
        <BackgroundVideo />
        <main>
          <Routes
            location={location}
            key={location.pathname}
          >
            <Route
              path="/"
              element={<Discover />}
            ></Route>
            <Route
              path="/projects"
              element={<Projects />}
            ></Route>
            <Route
              path="/services"
              element={<Services />}
            ></Route>
            <Route
              path="/contact"
              element={<Contact />}
            ></Route>
          </Routes>
        </main>
        <Footer />
      </div>
    </div>
  );
}

export default App;

const Logo = styled.div`
  height: 100vh;
  width: 100vw;
  display: flex;
  position: fixed;
  z-index: 100;
  align-items: center;
  justify-content: center;
  background: #0c1d36;
  img {
    opacity: 1;
    height: 30vh;
    transform: rotateY(180deg);
    animation: 2s rotate ease-in-out infinite;
    clip-path: circle(7.5vh at center 15vh);
    @keyframes rotate {
      0% {
        clip-path: circle(12vh at center 15vh);
      }
      50% {
        clip-path: circle(15vh at center 15vh);
      }
      100% {
        clip-path: circle(12vh at center 15vh);
      }
    }
  }
`;
